// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3ALIR","location":"Header_location__2-hXf"};